
import axios from 'axios'
import checkFormat from '@/utils/checkFormat.js'
import { areaCodeObj, motorCodeObj } from '../utils/const'
// import router from "../router/index"
import { Toast } from 'vant'
localStorage.removeItem('setMotorAreaName')
localStorage.removeItem('setMotorCode')
localStorage.removeItem('provinceName')
const userToken = checkFormat.getUrlKey('token')
if (!checkFormat.isEmpty(userToken)) {
  localStorage.setItem('setToken', userToken)
}
const areaName = checkFormat.getUrlKey('areaName')
if (!checkFormat.isEmpty(areaName)) {
  localStorage.setItem('setMotorAreaName', areaName)
  localStorage.setItem('setMotorCode', `${areaName}Code`)
} else if (!checkFormat.isEmpty(localStorage.getItem('setMotorAreaName'))) {
  const oldName = localStorage.getItem('setMotorAreaName')
  localStorage.setItem('setMotorAreaName', oldName)
  localStorage.setItem('setMotorCode', `${oldName}Code`)
} else {
  localStorage.setItem('setMotorAreaName', 'HE_NAN')
  localStorage.setItem('setMotorCode', `HE_NANCode`)
}
// console.log(receive.indexOf("orderId"), 'token')

// 添加拦截器
axios.interceptors.request.use((config, promise) => {
  // 给所有请求添加自定义header
  config.headers['Content-Type'] = 'application/json'
  config.headers['accept'] = 'application/problem+json'
  config.headers['Authorization'] = localStorage.getItem('setToken')
  // config.headers['Authorization'] = '12BD6B8153FD1C7C7A93BEC14E7860A5'
  // config.headers['BusinessKey'] = 'HNInsureMotor'
  if (localStorage.getItem('setMotorAreaName')) {
    config.headers['BusinessKey'] = areaCodeObj[localStorage.getItem('setMotorAreaName')]
  }
  config.headers['Tokentype'] = 'DEFULT'
  return config
}, error => { // 请求错误处理
  Promise.reject(error)
})

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    // 发生网络错误后会走到这里
    if (err.response.status === 401) {
      // C端外部调用token失效情况下 给弹窗提示
      const receive = window.location.href.split('#/')[1]
      console.log('请重新登录', process.env.API_HOST)
      // router.push({path:'/401'})
      if (localStorage.getItem('setChannelCode') === 'OCTOPUS') {
        window.location.href = process.env.API_HOST + '/app/salescompany/#/market/Mlogin'
        // window.location.href = 'https://test-open.zking.com/app/salescompany/#/market/Mlogin'
      } else if (localStorage.getItem('setChannelCode') === 'DP_OWXPA') {
        window.location.href = process.env.API_HOST + '/app/mall/m-web/?url=/Client/index#/Login?carProposal=1'
        // window.location.href ='https://test-open.zking.com/app/mall/m-web/?url=/Client/index#/Login?carProposal=1'
      } else if (localStorage.getItem('setChannelCode') === 'ZKICATM') {
        window.location.href = process.env.API_HOST + '/app/mall/m-web/?url=/market/index#/market/Login'
      } else if (receive.split('/')[0] === 'motor' && localStorage.getItem('setMotorCode')) {
        window.location.href = process.env.API_HOST + motorCodeObj[localStorage.getItem('setMotorCode')]
      } else if (receive.split('/')[0] === 'vehicle') {
        window.location.href = process.env.API_HOST + '/app/mall/car-proposal/#/vehicle'
      }
    } else {
      Toast(err.response.data)
    }
    return err.response
  })



// WEBPACK FOOTER //
// ./src/api/httpService.js